import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, FormControl, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { NewVulnerabilityService } from '../Data Service/new-vulnerability.service';
import { newAssessClass } from '../Data Service/newAssessClass';
import {ActivatedRoute,Router,Params} from '@angular/router';
import { IQuestion } from './IQuestion';
import { ThrottlingConstants } from '@azure/msal-common/dist/utils/Constants';
import { IQuesRes } from './user-view-assessment/IQuesRes';
import { IUserView } from './user-view-assessment/IUserView';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-new-assessment',
  templateUrl: './new-assessment.component.html',
  styleUrls: ['./new-assessment.component.css']
})
export class NewAssessmentComponent  {
//#region  Global declarations 
  objAssclass = new IUserView();
  EID:any;
  productForm: UntypedFormGroup;   
  errormessage: any;
  DDdataEVClient:any;
  DDdataEVContrName:any;
  DDdataEVContrNum:any;  
  EmailData:any;  
  //#endregion

  constructor(private spinner: NgxSpinnerService,private fb:UntypedFormBuilder,private service : NewVulnerabilityService, private _route : ActivatedRoute
    ,private _router : Router) {
   
    this.productForm = this.fb.group({
      quantities: this.fb.array([this.newQuantity()]) ,
    });
  }
  
  ngOnInit(): void {  
    this.getEVDD_Client();
    this.getEVDD_ContrName();
    this.getEVDD_ContrNum(); 
    this.getEVMail(); 

    let AID=this._route.snapshot.params.id; 
    if(AID !=0)
    {
this.getAssessData(AID);
    }    

  }

  getEVMail(){
    this.service.getEVMailData().subscribe((data : any)=>{      
      this.EmailData = data; 
    }, (error:any) => {
        // this.errormessage = error;
    })
  } 

  getEVDD_Client(){
    this.service.getEVClientDDData().subscribe((data : any)=>{      
      this.DDdataEVClient  = data;        
    }, (error:any) => {
        this.errormessage = error;
    })
  }

  getEVDD_ContrName(){
    this.service.getEVContrNameDDData().subscribe((data : any)=>{      
      this.DDdataEVContrName  = data;        
    }, (error:any) => {
        this.errormessage = error;
    })
  }

  getEVDD_ContrNum(){
    this.service.getEVContrNumData().subscribe((data : any)=>{      
      this.DDdataEVContrNum  = data;      
    }, (error:any) => {
        this.errormessage = error;
    })
  }

  getAssessData(AID : any){
    this.spinner.show();
    this.service.getAssessDataList(AID).subscribe(
      (data : any)=>{  
        this.objAssclass=data[0];        
        this.objAssclass.ContractNumber=data[0].ContractNumber.toString();      
        this.productForm.setControl("quantities", this.SetQtyValue(data));
        this.spinner.hide();
      }, (error:any) => {        
        this.errormessage = error;
      }
    )    
  }
  SetQtyValue(qtySet : IQuesRes[]): UntypedFormArray{
    const formmarray = new UntypedFormArray([]);
    qtySet.forEach(s => {
      formmarray.push(this.fb.group({
        QuestionID:s.QuestionID,
        Question: s.Question             
      }));
    });    
    return formmarray;
  }

  quantities() : UntypedFormArray {
    return this.productForm.get("quantities") as UntypedFormArray
  }
     
  newQuantity(): UntypedFormGroup {
    return this.fb.group({
      QuestionID: [''],      
      Question: [''],      
    })
  }

  AddAssessment(objAssess : IUserView){
    let assessVal : Array<IQuestion>=[];        

    for(let j=0;j<this.productForm.controls["quantities"].value.length;j++){
      var assessArrVal = new IQuestion();
      assessArrVal.QuestionID = this.productForm.controls["quantities"].value[j].QuestionID;
    assessArrVal.Question = this.productForm.controls["quantities"].value[j].Question;
      assessVal.push(assessArrVal);
    }
    // this.Eid = localStorage.getItem('UserID').substring(0,localStorage.getItem('UserID').lastIndexOf("@"));
    this.EID="shyam.valath.suresh";    
    var val  = {
      DateRaisedAssess : objAssess.DateRaised,
                Client : objAssess.ClientName,
                Contract : objAssess.ContractNumber,
                ContractName : objAssess.ContractName,
                TitleAssess : objAssess.AssessmentName,
                Question : assessVal, 
                LastUpdatedBy:this.EID,                             
              };           
                            
                if(val.DateRaisedAssess==""||val.Client=="" || val.Contract == null|| val.ContractName==null){
                  alert("Please fill the mandatory fields");
                }
                else{ 

if(val.Question[0].QuestionID){
  
              this.service.UpdateGCCAssessment(val).subscribe(res => {                                
                alert(res.toString());
                this._router.navigate(['/assessment-home']);
            });
}
else{
  this.service.addAssessment(val).subscribe(res => {                                
    alert(res.toString());
    this._router.navigate(['/assessment-home']);
});
}
              


            }                    
  }

  onSubmit(){
    this.AddAssessment(this.objAssclass);   
  }

  addQuantity() {
    this.quantities().push(this.newQuantity());
  }
   
  removeQuantity(i:number) {
    this.quantities().removeAt(i);
  }
  onCancel(){
    this._router.navigate(['/assessment-home']);
  }
}
